/* eslint-disable no-unused-expressions */
/* eslint-disable array-callback-return */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable no-unused-vars */
/* eslint-disable react/button-has-type */
/* eslint-disable max-len */
import React, { useState, useEffect, useContext } from 'react';
import { distributorService } from '../../service/distributor.service';
import ActivityLog from './Components/ActivityLog';
import AdditionalDiscountPercentage from './Components/AdditionalDiscountPercentage';
import AdditionalDiscountValue from './Components/AdditionalDiscountValue';
import AdorCash from './Components/AdorCash';
import DAP from './Components/DAP';
import GST from './Components/GST';
import Return from './Components/Return';
import CreditLimit from './Components/CreditLimit';
import SaveChangesModal from './Components/saveChangesModal';
import TradeDiscountPercentage from './Components/TradeDiscountPercentage';
import TradeDiscountValue from './Components/TradeDiscountValue';
import HeaderContext from '../../Components/Context/HeaderContext';
import FormulaSkeleton from './FormulaSkeleton';
import CashDiscount from './Components/CashDiscount';

function FormulaSettings() {
    const {
        isPopup,
        setisPopup,
        ErrorMessage,
        SetErrorMessage,
        SuccessMessage,
        SetSuccessMessage,
        colorValue,
        setcolorValue,
        HardRefresh,
        setHardRefresh,
        collapsed,
    } = useContext(HeaderContext);
    const attributes = {
        trade_discount_value: {
            LIST_PRICE: 'List Price',
            sub_total: 'Basic Value',
            trade_discount: 'Trade Discount',
            quantity: 'Quantity',
            additional_discount: 'Additional Discount',
            number: 'Number',
        },
        trade_discount_percentage: {
            LIST_PRICE: 'List Price',
            sub_total: 'Basic Value',
            trade_discount: 'Trade Discount',
            quantity: 'Quantity',
            additional_discount: 'Additional Discount',
            number: 'Number',
        },
        additional_discount_percentage: {
            LIST_PRICE: 'List Price',
            sub_total: 'Basic Value',
            trade_discount: 'Trade Discount',
            quantity: 'Quantity',
            additional_discount: 'Additional Discount',
            trade_discount_applied: 'Trade Discount Value',
            number: 'Number',
        },
        additional_discount_value: {
            LIST_PRICE: 'List Price',
            sub_total: 'Basic Value',
            trade_discount: 'Trade Discount',
            quantity: 'Quantity',
            additional_discount: 'Additional Discount',
            trade_discount_applied: 'Trade Discount Value',
            number: 'Number',
        },
        dap: {
            LIST_PRICE: 'List Price',
            sub_total: 'Basic Value',
            additional_discount_value: 'Additional Discount Value',
            trade_discount: 'Trade Discount',
            trade_discount_applied: 'Trade Discount Value',
            quantity: 'Quantity',
            additional_discount: 'Additional Discount',
            dap_percentage: 'DAP',
            number: 'Number',
        },
        ador_cash: {
            ador_cash_redeemmed: '',
            ador_cash_available: '',
        },
        gst: {
            consumables: '',
            equipments: '',
            mnr: '',
            others: '',
        },
        cash_discount: {
            percentage: '',
            message: '',
            overdue_status: null,
        },
        credit_limit: {
            credit_limit: '',
        },
        returns: {
            returns: '',
        },
    };
    const [formulaUpdated, setFormulaUpdated] = useState({});
    const [changesMade, setChangesMade] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [errorFields, setErrorFields] = useState(false);
    const [fetchedFormula, setFetchedFormula] = useState({});
    const [saveChangesModal, setSaveChangesModal] = useState(false);
    const [activityLogDetails, setActivityLogDetails] = useState([]);
    const [loading, setLoading] = useState(true);
    const operators = {
        '+': '+',
        '-': '-',
        '*': '*',
        '/': '/',
        '(': '(',
        ')': ')',
    };

    const fetchFormula = async () => {
        const response = await distributorService.FormulaSetting();
        if (response.error === false) {
            setLoading(false);
            setFetchedFormula(response.data.data);
        }
    };

    const fetchActivityLog = async () => {
        const response = await distributorService.FormulaActivityLog();
        if (response.error === false) {
            response.data.data.sort((a, b) => parseFloat(a.updated_at) - parseFloat(b.updated_at)).reverse();
            setActivityLogDetails(response.data.data);
        }
    };

    const validation = () => {
        const errorFieldsCurrent = [];
        Object.entries(formulaUpdated).map(([key, value]) => {
            if (['trade_discount_percentage', 'trade_discount_value', 'additional_discount_percentage', 'additional_discount_value', 'returns', 'credit_limit'].includes(key) && value === '') {
                errorFieldsCurrent.push(key);
            } else if (Object.values(value).includes('')) errorFieldsCurrent.push(key);
        });
        setErrorFields(errorFieldsCurrent);
        if (errorFieldsCurrent.length === 0) {
            setSaveChangesModal(true);
        }
    };

    useEffect(() => {
        fetchFormula();
        fetchActivityLog();
    }, []);
    const handleErrorMessage = (message, key) => {
        SetErrorMessage(message || 'Something went wrong');
        setcolorValue(true);
        setTimeout(() => {
            SetErrorMessage('');
            setcolorValue(false);
        }, 2000);
    };
    const handleSuccessMessage = (message, key) => {
        SetSuccessMessage(message);
        setTimeout(() => {
            SetSuccessMessage('');
            setcolorValue(false);
        }, 2000);
    };

    const handleSaveChanges = async () => {
        const payload = formulaUpdated;
        setSubmitted(true);
        const response = await distributorService.UpdateFormulaSetting(payload);
        if (!response.error && response.data.success_status) {
            handleSuccessMessage(response.data.message);
            fetchActivityLog();
            setFormulaUpdated({});
            setSubmitted(false);
        } else {
            handleErrorMessage(response.data.message);
            setSubmitted(false);
        }
        setSubmitted(false);
        setSaveChangesModal(false);
        setChangesMade(false);
    };

    useEffect(() => {
        setChangesMade(false);
    }, []);

    return (
        <div className="py-6 pl-[20px] pr-12 main-screen">
            {loading ? <FormulaSkeleton />
                : (
                    <div>
                        <div className="flex items-center pb-8">
                            <h5 className="text-xs4 font-bold text-[#090406]">Formula Settings</h5>
                        </div>
                        <div className="rounded-lg bg-[#F5F5FA] px-[30px] py-[22px]">
                            {Object.keys(fetchedFormula).length > 0 && (
                                <>
                                    <TradeDiscountPercentage
                                        attributes={attributes.trade_discount_percentage}
                                        operators={operators}
                                        params="trade_discount_percentage"
                                        formulaUpdated={formulaUpdated}
                                        setFormulaUpdated={setFormulaUpdated}
                                        fetchedFormula={fetchedFormula}
                                        setFetchedFormula={setFetchedFormula}
                                        setChangesMade={setChangesMade}
                                    />
                                    <TradeDiscountValue
                                        attributes={attributes.trade_discount_value}
                                        operators={operators}
                                        params="trade_discount_value"
                                        formulaUpdated={formulaUpdated}
                                        setFormulaUpdated={setFormulaUpdated}
                                        fetchedFormula={fetchedFormula}
                                        setChangesMade={setChangesMade}
                                    />
                                    <AdditionalDiscountPercentage
                                        attributes={attributes.additional_discount_percentage}
                                        operators={operators}
                                        params="additional_discount_percentage"
                                        formulaUpdated={formulaUpdated}
                                        setFormulaUpdated={setFormulaUpdated}
                                        fetchedFormula={fetchedFormula}
                                        setChangesMade={setChangesMade}
                                    />
                                    <AdditionalDiscountValue
                                        attributes={attributes.additional_discount_value}
                                        operators={operators}
                                        params="additional_discount_value"
                                        formulaUpdated={formulaUpdated}
                                        setFormulaUpdated={setFormulaUpdated}
                                        fetchedFormula={fetchedFormula}
                                        setChangesMade={setChangesMade}
                                    />
                                    <DAP
                                        attributes={attributes.dap}
                                        operators={operators}
                                        params="dap"
                                        formulaUpdated={formulaUpdated}
                                        setFormulaUpdated={setFormulaUpdated}
                                        fetchedFormula={fetchedFormula}
                                        setChangesMade={setChangesMade}
                                    />
                                    <AdorCash
                                        attributes={attributes.ador_cash}
                                        operators={operators}
                                        params="ador_cash"
                                        formulaUpdated={formulaUpdated}
                                        setFormulaUpdated={setFormulaUpdated}
                                        fetchedFormula={fetchedFormula}
                                        setChangesMade={setChangesMade}
                                    />
                                    <CashDiscount
                                        attributes={attributes.cash_discount}
                                        operators={operators}
                                        params="cash_discount"
                                        formulaUpdated={formulaUpdated}
                                        setFormulaUpdated={setFormulaUpdated}
                                        fetchedFormula={fetchedFormula}
                                        setChangesMade={setChangesMade}
                                    />
                                    <GST
                                        params="gst"
                                        formulaUpdated={formulaUpdated}
                                        setFormulaUpdated={setFormulaUpdated}
                                        fetchedFormula={fetchedFormula}
                                        setChangesMade={setChangesMade}
                                    />
                                    <CreditLimit
                                        params="credit_limit"
                                        formulaUpdated={formulaUpdated}
                                        setFormulaUpdated={setFormulaUpdated}
                                        fetchedFormula={fetchedFormula}
                                        setChangesMade={setChangesMade}
                                    />
                                    <Return
                                        params="returns"
                                        formulaUpdated={formulaUpdated}
                                        setFormulaUpdated={setFormulaUpdated}
                                        fetchedFormula={fetchedFormula}
                                        setChangesMade={setChangesMade}
                                    />

                                </>
                            )}
                        </div>
                        <div className="flex justify-center my-8">
                            <button
                                onClick={() => { validation(); }}
                                type="button"
                                className="w-[250px] py-3 bg-[#555259] rounded-lg text-sm63 font-bold text-[#ffffff]"
                                data-bs-toggle="modal"
                                data-bs-target="#saveFormulaSettings"
                                disabled={(Object.keys(formulaUpdated).length === 0)}
                            >
                                Save
                            </button>
                        </div>
                        <div className="flex justify-center my-8 ">
                            {errorFields.length > 0 && (
                                <div className="capitalize text-[red] mr-2 ">
                                    Error fields:
                                </div>
                            )}
                            {errorFields && errorFields.map((item, index) => (
                                <div className="capitalize text-[red] mr-2 ">
                                    {'  '}
                                    {item.replaceAll('_', ' ')}
                                    {errorFields.length > 1 && index !== errorFields.length - 1 && ','}
                                </div>
                            ))}
                        </div>
                        {saveChangesModal && (
                            <SaveChangesModal
                                saveChangesModal={saveChangesModal}
                                setSaveChangesModal={setSaveChangesModal}
                                handleSaveChanges={handleSaveChanges}
                                submitted={submitted}
                            />
                        )}
                        <ActivityLog
                            activityLogDetails={activityLogDetails}
                            setActivityLogDetails={setActivityLogDetails}
                        />
                    </div>
                )}
        </div>
    );
}

export default FormulaSettings;
